import { createClient } from '@supabase/supabase-js';
import { Preferences } from '@capacitor/preferences';
import { Capacitor } from '@capacitor/core';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Faltan las variables de entorno de Supabase. Añade VITE_SUPABASE_URL y VITE_SUPABASE_ANON_KEY a tu archivo .env.local');
}

// Custom storage client for Capacitor native platform to guarantee permanent storage
const capacitorStorage = {
  getItem: (key: string): Promise<string | null> => {
    return Preferences.get({ key }).then(res => res.value);
  },
  setItem: (key: string, value: string): Promise<void> => {
    return Preferences.set({ key, value });
  },
  removeItem: (key: string): Promise<void> => {
    return Preferences.remove({ key });
  }
};

export const supabase = createClient(supabaseUrl || '', supabaseAnonKey || '', {
  auth: {
    storage: Capacitor.isNativePlatform() ? capacitorStorage : localStorage,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: !Capacitor.isNativePlatform()
  }
});
